import React from 'react';
import {Bar} from 'react-chartjs-2';
import ChartContainer from './chartContainer';
import {formatNumberToDisplayWithCommas} from '../../../../common/shared';
import {getMonthlyChartLabels, getPeriodAverageValue} from '../chartLabelHelpers';
import './chartSetup';

const FeetPerShiftChart = ({chartData}) => {
    const labels = getMonthlyChartLabels(chartData.items);
    const values = chartData.items.map(item => item.avg_footage);
    const targetDataset = chartData.items.map(item => item.target);

    const data = {
        labels: labels,
        datasets: [
            {
                type: 'bar',
                data: values,
                backgroundColor: '#bfbfbf',
                order: 2,
                label: 'Feet Per Shift',
            },
            {
                type: 'line',
                data: targetDataset,
                backgroundColor: '#c00000',
                borderColor: '#c00000',
                order: 1,
                label: 'Target',
            }
        ],
    }

    const options = {
        scales: {
            y: {
                title: 'Feet Per Shift',
                beginAtZero: true,
            },
            x: {
                grid: {
                    drawOnChartArea: false,
                    tickLength: 10,
                },
                ticks: {
                    autoSkip: false,
                    maxRotation: 45,
                    minRotation: 0,
                }
            },
        },
        plugins: {
            legend: {
                reverse: true,
            },
        },
        maxBarThickness: 40,
    }

    const summaryItems = [
        {
            label: 'Period Avg',
            value: formatNumberToDisplayWithCommas(getPeriodAverageValue(chartData), 1),
        },
        {
            label: 'Current Target',
            value: formatNumberToDisplayWithCommas(chartData.current_target, 1),
        },
    ]

    return (
        <ChartContainer title="Feet Per Shift" summaryItems={summaryItems}>
            <Bar data={data} options={options}/>
        </ChartContainer>
    )
}

export default FeetPerShiftChart;
